import axios from 'axios';

import config from '../../../config.json';
import { AppDispatch, RootState } from '../store';

import { refreshTokenSuccess } from './authSlice';

export const refreshAccessToken = async (dispatch: AppDispatch, getState: () => RootState) => {
  const { refreshToken } = getState().auth;

  if (!refreshToken) {
    throw new Error('No refresh token available');
  }

  try {
    const response = await axios.post(`${config.BASE_URL}/auth/refreshToken`, {
      refreshToken,
    });

    if (!response.data.access_token) {
      throw new Error('Failed to refresh token');
    }

    dispatch(
      refreshTokenSuccess({
        accessToken: response.data.access_token,
        refreshToken: response.data.refresh_token,
      })
    );

    return response.data.access_token;
  } catch (error) {
    throw new Error(`Token refresh failed: ${error}`);
  }
};
